export default __webpack_public_path__ + "img/publication/grum_700.webp";